import jwtDecode from "jwt-decode";

const getLocalDevToken = () => ({
  isLocal: true,
  accessToken: process.env.GATSBY_LOCAL_DEBUG_ACCESS_TOKEN,
  isLoggedIn: process.env.GATSBY_LOCAL_DEBUG_IS_LOGGED_IN === "true",
  profileType: process.env.GATSBY_LOCAL_DEBUG_IS_PROFILE_TYPE,
  userId: process.env.GATSBY_LOCAL_DEBUG_USER_ID,
  userType: process.env.GATSBY_LOCAL_DEBUG_USER_TYPE,
  guestToken: process.env.GATSBY_LOCAL_DEBUG_GUEST_TOKEN,
  loading: false,
});

const getToken = () => {
  return new Promise((resolve, reject) => {
    if (process.env.GATSBY_IS_LOCAL_DEV === "true") {
      return resolve(getLocalDevToken());
    }
    return window.ikea.authentication.getTokens(async (error, tokens) => {
      if (error) {
        console.error(error); // eslint-disable-line no-console
        return reject(error);
      }

      const accessToken = tokens.auth && tokens.auth.value;
      const { isLoggedIn, profileType, userId, userType } =
        fetchUserDetailsFromToken(accessToken);
      return resolve({
        isLocal: false,
        accessToken,
        isLoggedIn,
        profileType,
        userId,
        userType,
        loading: false,
        guestToken: tokens.guest && tokens.guest.value,
      });
    });
  });
};

const fetchUserDetailsFromToken = (accessToken) => {
  if (accessToken) {
    const decodedToken = jwtDecode(accessToken);
    const partyUIdKey = Object.keys(decodedToken).find((key) =>
      key.includes("partyUId")
    );
    const profileTypeKey = Object.keys(decodedToken).find((key) =>
      key.includes("customerType")
    );
    const userId = partyUIdKey
      ? decodedToken[partyUIdKey]
      : decodedToken.sub || accessToken;
    const userType = partyUIdKey ? "R" : "G";
    const profileType = profileTypeKey ? decodedToken[profileTypeKey] : "";
    return {
      profileType,
      userId,
      userType,
      isLoggedIn: userType === "R",
    };
  }
  return {
    userId: "",
    profileType: "",
    userType: "G",
    isLoggedIn: false,
  };
};

const isExpiredOrInvalidToken = (accessToken) => {
  if (accessToken) {
    const decodedToken = jwtDecode(accessToken);
    return decodedToken.exp < new Date().getTime() / 1000;
  }
  return true;
};
export { getToken, fetchUserDetailsFromToken, isExpiredOrInvalidToken };
